import React from 'react'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import CloudOffIcon from '@mui/icons-material/CloudOff'

import DocumentCard from '@/components/ui/cards/DocumentCard'

export type DocumentProps = {
  disableChangeName?: boolean
  disableAnnotation?: boolean
  extension: string
  fileKey: string
  name: string
  onSaveFileName?: (filename: string, key: string) => void
  onSaveFileAnnotation?: (file: File, key: string) => void
  size?: string
  src: string
  isOffline?: boolean
  onOpenPreview?: () => void
}

export default function Document(props: DocumentProps) {
  const { extension, name, onOpenPreview, size, src, isOffline = false } = props

  return (
    <Box sx={{ position: 'relative' }}>
      <DocumentCard
        extension={extension}
        onClick={onOpenPreview}
        primaryText={`${name}.${extension}`}
        secondaryText={size}
        src={src}
        sx={{ margin: '0 auto' }}
      />
      {isOffline && (
        <Chip
          icon={<CloudOffIcon />}
          label="Offline"
          size="small"
          color="warning"
          sx={{
            position: 'absolute',
            top: 4,
            left: 4,
            fontSize: '0.7rem',
            height: '20px',
            '& .MuiChip-icon': {
              fontSize: '0.8rem',
            },
          }}
        />
      )}
    </Box>
  )
}
